/* istanbul ignore file */
import { Json } from '@se/cp.common';
import { DataBinding } from '@se/se.ui.html5';
import { of } from 'rxjs';

import { ICpEntity, ICpEntityFactory } from './interfaces';

export class CpUndoEntity implements ICpEntity {
    Id!: never;

    get isModified() {
        this.failWithError('isModified');

        return true;
    }

    get isModified$() {
        this.failWithError('isModified$');

        return of(false);
    }

    get isValid$() {
        this.failWithError('isValid$');

        return of(false);
    }

    parent!: never;
    autoUpdatedPropertyList$!: never;
    isAutoUpdated!: never;
    isValid!: never;
    path: DataBinding;

    constructor(_: ICpEntityFactory, readonly originalEntity: ICpEntity) {
        this.path = originalEntity.path ?? new DataBinding();
        originalEntity.destroy();
    }

    addAutoUpdated(): never {
        this.failWithError('addAutoUpdated');
    }

    addEntityToList(): never {
        this.failWithError('addToList');
    }

    destroy() {
        /* noop */
    }

    forOwn() {
        this.failWithError('forOwn');
    }

    getAllEntities(): never {
        this.failWithError('getEntities');
    }

    getNestedPropertyValue(): never {
        this.failWithError('getNestedPropertyValue');
    }

    getPropertyErrorStatus(): never {
        this.failWithError('getPropertyErrorStatus');
    }

    getSelectedEntity(): never {
        this.failWithError('getEntity');
    }

    getEntity(): never {
        this.failWithError('getList');
    }

    getPropertyPrimitiveValue(): never {
        this.failWithError('getPropertyPrimitiveValue');
    }

    getPropertyValue(): never {
        this.failWithError('getPropertyValue');
    }

    getValue(): never {
        this.failWithError('getValue');
    }

    hasProperty(): never {
        this.failWithError('hasProperty');
    }

    navigateToPath(): never {
        this.failWithError('navigateToPath');
    }

    propertyErrorStatus(): never {
        this.failWithError('propertyErrorStatus');
    }

    remove(): false {
        return false;
    }

    removeEntityByGuid(): false {
        return false;
    }

    select(): never {
        this.failWithError('select');
    }

    setPropertyErrorStatus(): never {
        this.failWithError('setPropertyErrorStatus');
    }

    setPropertyValue(): never {
        this.failWithError('setPropertyValue');
    }

    setValue(): never {
        this.failWithError('setValue');
    }

    toJSON(): Json {
        return null;
    }

    updatePath(): never {
        this.failWithError('updatePath');
    }

    private failWithError(action: string): never {
        throw new Error(`Cannot ${action} of a deleted entity at path ${this.originalEntity.path}.`);
    }
}
